<template>
  <svg
    class="favorite-con-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.03033 4.46967L5.96967 5.53033L8.43934 8L5.96967 10.4697L7.03033 11.5303L10.5607 8L7.03033 4.46967Z"
      fill="currentColor"
    />
  </svg>
</template>

<style scoped lang="scss">
.favorite-con-icon {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
